import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateProviderStudioBody } from "@shared-kernel/application/ports/provider/provider-repository";

export const updateProviderStudio = createAsyncThunk<void, UpdateProviderStudioBody, { extra: Partial<Dependencies> }>(
  "provider/studio/update",
  async (body, { extra: { providerRepository } }) => {
    await providerRepository!.updateStudio(body);
  },
);
